import { dcpcApi } from './dcpcApi';
import { tags } from './tags';
import { STATION_ENTITY_TAG } from './stationEntityApi';

const {
  CREATE_DATASOURCE_PROGRAM_BLOCK_TAG,
  DELETE_DATASOURCE_PROGRAM_BLOCK_TAG,
} = tags;
export const DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG = 'DATASOURCE_PROGRAM_BLOCKS';

dcpcApi.enhanceEndpoints({
  addTagTypes: [
    DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG,
    DELETE_DATASOURCE_PROGRAM_BLOCK_TAG,
    CREATE_DATASOURCE_PROGRAM_BLOCK_TAG,
  ],
});
const datasourceProgramBlocksApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getDatasourceProgramBlocksById: builder.query({
      query: (id) => ({
        url: `datasource-program-blocks/${id}`,
        method: 'GET',
      }),
      providesTags: [CREATE_DATASOURCE_PROGRAM_BLOCK_TAG],
    }),

    updateDatasourceProgramBlock: builder.mutation({
      query: (datasourceProgramBlock) => ({
        method: datasourceProgramBlock.id ? 'PUT' : 'POST',
        url: `datasource-program-blocks${datasourceProgramBlock.id ? `/${datasourceProgramBlock.id}` : ''}`,
        body: datasourceProgramBlock,
      }),
      invalidatesTags: [DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG, 'DEVICES', CREATE_DATASOURCE_PROGRAM_BLOCK_TAG],
    }),

    deleteDatasourceProgramBlock: builder.mutation({
      query: (id) => ({
        method: 'DELETE',
        url: `datasource-program-blocks/${id}`,
      }),
      invalidatesTags: [DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG, DELETE_DATASOURCE_PROGRAM_BLOCK_TAG],
    }),

    getDatasourceProgramBlockByStationEntityId: builder.query({
      query: (stationEntityId) => `/datasource-program-blocks/entity/${stationEntityId}`,
      providesTags: [STATION_ENTITY_TAG],
    }),

    getDatasourceProgramBlockByDatasourceProgramId: builder.query({
      query: (datasourceProgramId) => `datasource-program-blocks/datasource-program/${datasourceProgramId}`,
      providesTags: [CREATE_DATASOURCE_PROGRAM_BLOCK_TAG, DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG],
    }),
  }),
});

export const {
  useGetDatasourceProgramBlocksByIdQuery,
  useUpdateDatasourceProgramBlockMutation,
  useDeleteDatasourceProgramBlockMutation,
  useGetDatasourceProgramBlockByStationEntityIdQuery,

  useGetDatasourceProgramBlockByDatasourceProgramIdQuery,
} = datasourceProgramBlocksApi;
